import { Component } from "vue-property-decorator";
import { isOutdatedBrowser } from "../helpers/outdated-browser";
import LazyMedia from "./lazy-media-dom";

@Component
class LazyLogo extends LazyMedia {
    public source = "";
    public width: number = 0;
    public height: number = 0;
    public isLoaded = false;
    public scale: number = 1;
    public ratio: number = 1;

    public updated() {
        const image = this.$el.querySelector("img");

        if (image) {
            const source = image.getAttribute("src") || "";
            const ext = source.slice((source.lastIndexOf(".") - 1) + 2);

            image.addEventListener("load", async () => {
                let width = image.naturalWidth;
                let height = image.naturalHeight;

                if (ext === "svg") {
                    const parser = new DOMParser();
                    const file = await fetch(this.source, { credentials: "include" });
                    const fileAsText = await file.text();
                    const fileAsSvg = parser.parseFromString(fileAsText, "image/svg+xml");
                    const svg = fileAsSvg.getElementsByTagName("svg")[0];

                    if (svg) {
                        width = svg.width.baseVal.value || svg.viewBox.baseVal.width;
                        height = svg.height.baseVal.value || svg.viewBox.baseVal.height;
                    }
                }

                this.width = width;
                this.height = height;
                this.ratio = this.width / this.height;

                // object-fit polyfill for IEdge <= 15
                if (typeof window.objectFitPolyfill === "function" && isOutdatedBrowser && ext !== "svg") {
                    window.objectFitPolyfill(image);
                }

                this.scaleImg();
                window.addEventListener("resize", this.scaleImg);

                this.isLoaded = true;
            });
        }
    }

    public scaleImg() {

        let thisArea;
        const parentW = (this.$el.parentNode as HTMLElement).offsetWidth;
        const parentH = (this.$el.parentNode as HTMLElement).offsetHeight;
        const parentArea = parentW * parentH;
        const parentRatio = parentW / parentH;

        if (this.ratio >= parentRatio) {
            thisArea = parentW * this.height * (parentW / this.width);
        } else {
            thisArea = parentH * this.width * (parentH / this.height);
        }

        const ratio = thisArea / parentArea;

        const minScale = 0.4;
        this.scale = (Math.round((((1 - ratio) * (1 - minScale)) + minScale) * 100) / 100);
        (this.$el as HTMLElement).style.transform = `translate(-50%,-50%) scale(${this.scale})`;
    }
}

export default LazyLogo;
